import { render, staticRenderFns } from "./agency.vue?vue&type=template&id=80abbbcc&scoped=true"
import script from "./agency.vue?vue&type=script&lang=js"
export * from "./agency.vue?vue&type=script&lang=js"
import style0 from "./agency.vue?vue&type=style&index=0&id=80abbbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80abbbcc",
  null
  
)

export default component.exports